import React from "react";


const NoteDisplay = ({ note, scale, scaleType }) => {
  note = note.replace('#', 'sharp');

  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get('no-symbols');
  console.log(paramValue);
  
  
  if(paramValue !== 'true'){
    note = "/with-symbols/" + note;
    console.log(note);
  } 
  const encodedNote = encodeURIComponent(note);
  const handleError = (event) => {
    event.target.src = "/assets/" + scale + "/" + scaleType + "/" + encodedNote + ".png";
  };

  return (
    <div
      className={`transition-opacity duration-500 ${
        note ? "opacity-100" : "opacity-0"
      } flex flex-col items-center justify-center w-full h-full`}
    >
      <h2 className="text-2xl font-bold mb-4">Guess the Note</h2>
      {note && (
        <img
          src={`/assets/${scale}/${scaleType}/${encodedNote}.svg`}
          onError={handleError}
          alt={note}
          className="w-3/5 min-w-96 h-72 object-fill mx-auto" // Adjusted class for demonstration
          // Ensures dimensions are filled as specified
        />
      )}
    </div>
  );
};

export default NoteDisplay;
